// Business types constant - used across project creation and template management
export const BUSINESS_TYPES = [
  "Ατομική Επιχείρηση",
  "Ομόρρυθμη Εταιρεία (Ο.Ε.)",
  "Ετερόρρυθμη Εταιρεία (Ε.Ε.)",
  "Ιδιωτική Κεφαλαιουχική Εταιρεία (Ι.Κ.Ε.)",
  "Εταιρεία Περιορισμένης Ευθύνης (Ε.Π.Ε.)",
  "Ανώνυμη Εταιρεία (Α.Ε.)",
  "Κοινωνική Συνεταιριστική Επιχείρηση (Κοιν.Σ.Επ.)",
  "Αγροτικός Συνεταιρισμός",
  "Αστική Εταιρεία",
  "Αστική Μη Κερδοσκοπική Εταιρεία (ΑΜΚΕ)",
  "Ναυτική Εταιρεία Πλοίων Αναψυχής (ΝΕΠΑ)",
];
